import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getJWtDetails } from '../../utils/AppUtils';
import { dashboardViewSelector, userProfileSelector } from '../../pages/Dashboard/selectors';
import { getWorkspaceRedirectIfNeeded } from '../../utils/dashboardView';

/**
 * Keeps signed-in users on the route family that matches their `dashboard_view`
 * (brand → `/brand`, creator → feed, jury → jury duty).
 */
export function DashboardWorkspaceRedirect() {
    const location = useLocation();
    const navigate = useNavigate();
    const view = useSelector(dashboardViewSelector);
    const user = useSelector(userProfileSelector);
    const { isSignedIn } = getJWtDetails();

    useEffect(() => {
        if (!isSignedIn || !user?._id) return;
        const to = getWorkspaceRedirectIfNeeded(location.pathname, view);
        if (to) navigate(to, { replace: true });
    }, [location.pathname, view, isSignedIn, user?._id, navigate]);

    return null;
}
